import React, { useState, useRef, useEffect } from 'react';
import { Upload, X } from 'lucide-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Card, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import { useLoader } from '../../_helper/LoaderContext';
import { toast } from 'react-toastify';
import { addHeaderFooterValue } from './service/setting-service';

export default function FooterHome() {
    const [logoPreview, setLogoPreview] = useState(null);
    const { setLoading } = useLoader()
    const [footerText, setFooterText] = useState(``);

    useEffect(() => {
        const header = JSON.parse(localStorage.getItem("header"))
        setFooterText(header.footerText)
    }, [])

    const handelAdd = async () => {
        setLoading(true)
        try {
            const form_data = new FormData();
            form_data.append("footerText", footerText);
            const res = await addHeaderFooterValue(form_data)
            if (res.data.success == true) {
                toast.success(res.data.message);
                const headerFooter = {
                    headerTest: res.data.data.headerText,
                    footerText: res.data.data.footerText,
                    headerLogo: res.data.data.headerLogo
                }
                localStorage.setItem("header", JSON.stringify(headerFooter))
                // setFooterText("");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Breadcrumbs mainTitle="Footer Setting" parent="Home" title="Footer Setting" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <Card className="tw-shadow-xl tw-border-0 tw-overflow-hidden">
                            {/* PREVIEW SECTION */}
                            <div className="tw-p-8">
                                <div className=" tw-p-6 tw-pt-0 tw-min-h-32">
                                    <div className="tw-gap-8">

                                        {/* Logo */}
                                        {logoPreview ? (
                                            <img
                                                src={logoPreview}
                                                alt="Footer logo"
                                                className="tw-h-12 tw-object-contain tw-max-w-40"
                                            />
                                        ) : (
                                            <div className="tw-w-32" />
                                        )}

                                        {/* Live Text Preview */}
                                        <div
                                            className="
                                    tw-w-full
                                    [&>*]:tw-block [&>*]:tw-my-0 [&>*]:tw-leading-tight

                                    /* Inline alignment */
                                    [&_[style*='text-align:left']]:tw-text-left
                                    [&_[style*='text-align:center']]:tw-text-center
                                    [&_[style*='text-align:right']]:tw-text-right
                                    [&_[style*='text-align:justify']]:tw-text-justify

                                    /* Quill alignment classes */
                                    [&_.ql-align-left]:tw-text-left
                                    [&_.ql-align-center]:tw-text-center
                                    [&_.ql-align-right]:tw-text-right
                                    [&_.ql-align-justify]:tw-text-justify
                                "
                                            dangerouslySetInnerHTML={{ __html: footerText }}
                                        />

                                        <div className="tw-w-32" />
                                    </div>
                                </div>
                                <hr className="tw-border-t-2 tw-border-green-700" />
                                <p className="tw-text-center tw-text-sm tw-font-medium tw-text-gray-600 tw-mb-3">
                                    Footer Preview (as it will appear on reports)
                                </p>
                            </div>

                            {/* Top Section */}
                            <div className="tw-p-8 tw-pb-4 tw-pt-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Text Editor */}
                                        <div className="lg:tw-col-span-2">
                                            <div className="tw-border tw-border-gray-300 tw-rounded-lg tw-overflow-hidden">
                                                <ReactQuill
                                                    theme="snow"
                                                    value={footerText}
                                                    onChange={setFooterText}
                                                    className="tw-h-80"
                                                    placeholder={`ClinicDots Diagnostic Center\n123, MG Road, Near City Hospital\nMumbai - 400001, Maharashtra\nPhone: +91 98765 43210 | Email: info@example.com\nNABL Accredited | ISO 9001:2015 Certified`}
                                                    modules={{
                                                        toolbar: [
                                                            [{ header: [1, 2, 3, false] }],
                                                            ['bold', 'italic'],
                                                            [{ align: ['', 'center', 'right', 'justify'] }],
                                                            [{ color: [] }, { background: [] }],
                                                            ['clean']
                                                        ]
                                                    }}
                                                    formats={[
                                                        'header', 'bold', 'italic',
                                                        'align', 'color', 'background'
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tw-text-right mt-4">
                                        <button className="btn btn-primary" onClick={handelAdd}>
                                            Save Footer Design
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
